import { Component, OnInit } from '@angular/core';
import {ExternalpageService, externalpageTypes, externalpageImageTypes} from '../../shared/services/externalpage.service';
import {ExternalpageOverview} from '../../class/externalpage-overview';
import {DomainService} from '../../shared/services/domain.service';

@Component({
    selector: 'app-page-posts',
    templateUrl: './page-posts.component.html',
    styleUrls: ['./page-posts.component.scss'],
    standalone: false
})
export class PagePostsComponent extends ExternalpageOverview implements OnInit {

  externalpageTypes = externalpageTypes;
  externalpageImageTypes = externalpageImageTypes;

  public nodes :any = [];

  public view = {
    pageType: externalpageTypes.Post,
    queryParams: {
      pageSize: 9,
      pageNumber: 1,
      totalItems: 0
    },
    data: <any[]> [],
  }

  /**
   * Constructor
   *
   * @param ExternalpageService externalpageService
   */
  constructor(
    public externalpageService: ExternalpageService,
    protected domain: DomainService
  ) {

    super(externalpageService, domain);
  }

  /**
   * Ng on init
   */
  ngOnInit(): void {

    this.loadData();

  }

}
